import type {GeoRefAddress} from "@reva/shared/geo-reference";

import {georefAddressStableKey} from "../../util/componentUtil";
import AddressMap from "../address/AddressMap";

interface AmbiguousAddressMapProps {
    /** the currently highlighted address candidate (rendered as a map), or null */
    highlightAmbiguousAddress: GeoRefAddress | null;
}

export function AmbiguousAddressMap({highlightAmbiguousAddress}: AmbiguousAddressMapProps) {
    return (
        highlightAmbiguousAddress && (
            <AddressMap key={georefAddressStableKey(highlightAmbiguousAddress)} address={highlightAmbiguousAddress} />
        )
    );
}
